<template>
    <v-container>
        <v-layout>
            <v-flex xs12>
                <StoreSuppliers></StoreSuppliers>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import StoreSuppliers from "../../components/store/StoreSuppliers.vue";

export default {
    components: {
        StoreSuppliers
    },
    props: [
        
    ],
    data() {
        return {
            
        };
    },
    computed: {
        
    },
    methods: {
        
    }
};
</script>

<style>

</style>
